export { mapSanityStoreToAlgoliaStore } from './lib/store/mapSanityStoreToAlgoliaStore'
export type { SanityStoreType } from './lib/store/types'

export { mapSanityUtilityPageToAlgoliaUtilityPage } from './lib/utilityPage/mapSanityUtilityPageToAlgoliaUtilityPage'
export type { SanityUtilityPageType } from './lib/utilityPage/types'

export { getIndexName } from './lib/getIndexName'

export { sanityAlgolia } from './lib/indexer'
